import React from 'react'

export default function Footer() {
    return (
        <footer class="footer">
            © 2024 BnbPools. All rights reserved.
        </footer>
    )
}
